module.exports = ".example-h2 {\n  margin: 10px; }\n\n.example-section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-mechanics/individual-stat/individual-stat.component.scss
// module id = ./src/app/character/character-sheet/character-sheet-mechanics/individual-stat/individual-stat.component.scss
// module chunks = main